import { useState } from 'react'
import { PostPrivacy } from '@wellesley/openapi'

const usePrivacyHandlers = (
  isComment: boolean,
  initialPrivacyOverride?: PostPrivacy,
) => {
  const initialPrivacy =
    initialPrivacyOverride || (isComment ? 'FOLLOW_POST' : 'PUBLIC')

  const [privacy, setPrivacy] = useState<PostPrivacy>(initialPrivacy)

  const resetPrivacy = () => setPrivacy(initialPrivacy)

  return { privacy, setPrivacy, resetPrivacy }
}

export { usePrivacyHandlers }
